import React, { useEffect, useState } from 'react';
import dotProp from 'dot-prop-immutable';
import { DebounceInput } from 'react-debounce-input';

/* Common */
import { MultiSelectList, Range, RangeListFilter, SelectDropdown } from '~/components/common';

/* Utilities */
import { getSuffix } from '~/utilities';

export default function Filter({ filterGroup, filterGroupIndex, filters, className = '', updateRangeFilter, updateChoicesFilter }) {
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        if (searchTerm === '') {
            return;
        }

        setSearchTerm('');
    }, [filters]);

    return (
        <div className={(`filter ${ className }`).trim()}>
            <div className="row gutters-1">
                {filters.map((filter) => {
                    const filterIndex = filters.indexOf(filter);

                    if (filter.viewType === 'multi_select' && filter.filterKey !== 'source') {
                        let nameMapping = null;
                        if (filter.filterKey === 'btw_marge') {
                            nameMapping = {
                                B: 'BTW',
                                M: 'Marge'
                            }
                        }

                        if (filter.filterKey === 'sources') {
                            nameMapping = {
                                occasions: 'Occasions',
                                nieuw: 'Nieuw',
                                demo: 'Demo',
                                company_cars: 'Company Cars',
                            }
                        }

                        const searchedChoices = filter.choices.map((choice) => ({ ...choice })).filter((choice) => choice.name.toLowerCase().includes(searchTerm.toLowerCase()));

                        return (
                            <div className="col-12" key={filterGroupIndex}>
                                {filter.filterKey === 'brand' ? (
                                    <DebounceInput
                                        debounceTimeout={300}
                                        type="text"
                                        className="form-control form-control--search mb-5"
                                        placeholder="Zoek op merk"
                                        value={searchTerm}
                                        onChange={(event) => setSearchTerm(event.target.value)}
                                    />
                                ) : null}
                                <MultiSelectList
                                    className="list-group list-group-flush"
                                    parentFilters={filterGroup.filters}
                                    nameMapping={nameMapping}
                                    filter={filter}
                                    searchedChoices={searchedChoices}
                                    groupIndex={filterGroupIndex}
                                    filterIndex={filterIndex}
                                    key={filterIndex}
                                    suffix={getSuffix(filter.filterKey)}
                                    showCount={true}
                                    updateFilters={(filters) => {
                                        if (filter.filterKey === "sources") {
                                            const newChoices = filters[filterIndex].choices;
                                            const isOccasionsActive = newChoices.find((choice) => choice.key === 'occasions')?.active;
                                            const wasOccasionsActive = filter.choices.find((choice) => choice.key === 'occasions')?.active;
                                            const demoIndex = newChoices.findIndex((choice) => choice.key === 'demo');

                                            if (isOccasionsActive && !wasOccasionsActive && demoIndex !== -1) {
                                                filters = dotProp.set(filters, `${ filterIndex }.choices.${ demoIndex }.active`, true);
                                            }
                                        }

                                        updateChoicesFilter(filters);
                                    }}
                                />
                            </div>
                        );
                    }

                    if (filter.viewType === 'select') {
                        const { name, filterKey, choices } = filter;

                        return (
                            <div className="col-12" key={filterGroupIndex}>
                                <SelectDropdown
                                    id={filterKey}
                                    className="custom-select"
                                    name={filterKey}
                                    emptyValueLabel={`Selecteer ${ name }`}
                                    options={choices}
                                    onChange={(options) => {
                                        updateRangeFilter(filter, filterIndex, options, 'choices');
                                    }}
                                />
                            </div>

                        )
                    }

                    if (filter.viewType === 'range') {
                        const { name, minBounds, maxBounds, value, filterKey } = filter;
                        const { selected_min, selected_max } = value;

                        const rangeValue =
                            typeof selected_max !== 'undefined' && typeof selected_min !== 'undefined'
                                ? { min: selected_min, max: selected_max }
                                : { min: minBounds, max: maxBounds };

                        let prefix = '';

                        switch (filterKey) {
                            case 'price':
                                prefix = '€';
                                break;
                        }

                        return (
                            <div className="col-12" key={filterGroupIndex}>
                                <Range
                                    prefix={prefix}
                                    minBounds={minBounds}
                                    maxBounds={maxBounds}
                                    value={rangeValue}
                                    name={filter.filterKey}
                                    filterName={name}
                                    onChangeComplete={(value) => {
                                        updateRangeFilter(filterGroupIndex, filterIndex, value, undefined);
                                    }}
                                    thousandSeparator={filter.filterKey !== 'bouwjaar' ? '.' : ''}
                                    decimalSeparator={','}
                                />
                            </div>
                        );
                    }

                    if (filter.viewType === 'range_list') {
                        const { selectedMinValue, selectedMaxValue } = filter;

                        return (
                            <div className="col-12" key={filterGroupIndex}>
                                <RangeListFilter
                                    filter={filter}
                                    value={{
                                        min: selectedMinValue,
                                        max: selectedMaxValue,
                                    }}
                                    updateFilters={(value, type) => {
                                        updateRangeFilter(filter, filterIndex, value, type);
                                    }}
                                />
                            </div>
                        );
                    }
                })}
            </div>
        </div>
    );
}
